import PropTypes from "prop-types";


export const MoneyPropType = PropTypes.string;
